var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_vm._t("default"),(_vm.errors)?_c('p',{staticClass:"text-red",domProps:{"textContent":_vm._s(_vm.errors_texto)}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }